import * as React from 'react';
import { Col, Label } from "reactstrap";
import InputRange from "react-input-range";
import { Map } from "./Map";
import { SearchBar, IAgencyCountry, IOnSelectChange } from "./SearchBar";
import { IAlertInfo } from './../types';
import { IAuthState } from 'src/modules/Auth/store/types';
import { CountryRegionData } from 'src/packages/country-selector/data';
import { IAgency } from 'src/share/types/agency';

export interface IMapFormProps {
  alertInfo: IAlertInfo
  auth: IAuthState
  onSelectSearchBar: (change: IOnSelectChange) => void
  setValue: (path: string, value: any) => Promise<any>
  form: (key: string, required?: boolean) => any;
}

export default class MapForm extends React.Component<IMapFormProps> {
  public getAgencyCountry(): IAgencyCountry | null {
    const { agencyCode } = this.props.alertInfo
    if (agencyCode || agencyCode !== "ALL") {
      return this.findCountryByAgency(agencyCode);
    }
    return null;
  }
  public findCountryByAgency(agencyCode: string): IAgencyCountry | null {
    if (!agencyCode) {
      return null;
    }
    const { country } = this.props.auth && this.props.auth.agencies && this.props.auth.agencies.find(agency => agency.code === agencyCode) || {} as IAgency
    return {
      countryCode: this.getCountryCodeByName(country) || "",
      code: agencyCode
    }
  }
  public getCountryCodeByName(name) {
    const country = CountryRegionData.find((c) => c.countryName === name);
    return country ? country.countryShortCode : null;
  }

  public onAddresChange = (address) => {
    this.props.setValue("location", address);
  }

  public formatMiles = value => `${value} miles`;

  public render() {
    const { alertInfo, auth, form } = this.props
    const { radius, center, location } = alertInfo;
    const { agencyCode } = auth
    const agency = this.getAgencyCountry();
    return (
      <>
        <Label className={"affected-label"}>Designated Radius</Label>
        <Col className={"slider-container col-12"}>
          <InputRange
            {...form("radius")}
            formatLabel={this.formatMiles}
            maxValue={1000}
            minValue={5}
            step={5}
          />
        </Col>
        <Col className="mapContainer" md={12}>
          <Map
            radius={radius}
            center={center}
          />
          <SearchBar
            address={location}
            agency={agency}
            agencyCode={agencyCode}
            {...form("center")}
            onSelect={this.props.onSelectSearchBar}
            onChange={this.onAddresChange}
          />
        </Col>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/MapForm.tsx